<template>
  <vx-card title="Umsatz nach Liefergebiet">
    <vue-apex-charts
      type="bar"
      :height="chartHeight"
      :options="chartOptions"
      :series="series"
    />
  </vx-card>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  name: "AnalyticsRevenueByArea",
  components: { VueApexCharts },
  computed: {
    areas() {
      return this.$store.state.analytics.revenueByArea || [];
    },
    chartHeight() {
      return Math.max(250, this.areas.length * 32);
    },
    series() {
      return [
        {
          name: "Umsatz",
          data: this.areas.map((a) => Math.round(a.revenue * 100) / 100),
        },
      ];
    },
    labels() {
      return this.areas.map((a) => `${a._id} ${(a.city || "").trim()}`);
    },
    chartOptions() {
      return {
        chart: {
          toolbar: { show: false },
          foreColor: "#c2c6dc",
          background: "transparent",
        },
        theme: { mode: "dark" },
        grid: { borderColor: "rgba(255,255,255,0.06)" },
        plotOptions: {
          bar: {
            horizontal: true,
            borderRadius: 4,
            barHeight: "65%",
          },
        },
        xaxis: {
          categories: this.labels,
          labels: { formatter: (val) => (val / 1000).toFixed(0) + "k €" },
        },
        yaxis: {
          labels: { style: { fontSize: "12px" } },
        },
        dataLabels: {
          enabled: true,
          formatter: (val) =>
            val.toLocaleString("de-DE", {
              maximumFractionDigits: 0,
            }) + " €",
          style: {
            fontSize: "11px",
            fontWeight: 600,
            colors: ["#fff"],
          },
        },
        colors: ["#C41E2A"],
        fill: { opacity: 0.75 },
        tooltip: {
          y: {
            formatter: (val) =>
              val.toLocaleString("de-DE", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }) + " €",
          },
        },
      };
    },
  },
};
</script>
